/* Pensualizei - video de fundo do hero (image-banner .demo3-image-banner)
   Injeta 2 <video> sobrepostos com crossfade -> loop "sem parada brusca".
   Fallback: se o JS/video falhar, a imagem original do banner permanece. */
(function () {
  var VURL = "https://cdn.shopify.com/videos/c/o/v/5ac54b54fe5143a3b47c51199ba86414.mp4";
  var FADE = 1.0; // segundos de dissolucao no ponto de emenda

  function makeVideo(active) {
    var v = document.createElement('video');
    v.className = 'ps-hero-video' + (active ? ' is-active' : '');
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    var s = document.createElement('source'); s.src = VURL; s.type = 'video/mp4';
    v.appendChild(s);
    return v;
  }

  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function setup(media) {
    if (media.__psHeroVideo) return; media.__psHeroVideo = true;
    var a = makeVideo(true), b = makeVideo(false);
    media.classList.add('ps-has-video');
    media.appendChild(a); media.appendChild(b);
    var vids = [a, b], active = 0;
    a.addEventListener('loadeddata', function () { media.classList.add('ps-video-ready'); }, { once: true });
    a.addEventListener('error', function () { media.classList.remove('ps-video-ready'); });
    play(a);
    function tick() {
      var v = vids[active], d = v.duration;
      if (d && v.currentTime >= d - FADE) {
        var n = active ^ 1, nv = vids[n];
        if (!nv.classList.contains('is-active')) {
          try { nv.currentTime = 0; } catch (e) {}
          play(nv);
          nv.classList.add('is-active');
          v.classList.remove('is-active');
          (function (old) { setTimeout(function () { try { old.pause(); old.currentTime = 0; } catch (e) {} }, (FADE * 1000) + 150); })(v);
          active = n;
        }
      }
    }
    vids.forEach(function (v) { v.addEventListener('timeupdate', tick); });
  }

  function init() {
    var list = document.querySelectorAll('.demo3-image-banner .banner__media');
    for (var i = 0; i < list.length; i++) {
      // so o container que tem a imagem de fundo (evita placeholders)
      if (list[i].querySelector('img') || list[i].classList.contains('ps-has-video')) setup(list[i]);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* Pensualizei - WISHLIST: clicar so alterna (preenche/desmarca), NUNCA redireciona.
   O tema (dt_wishlist.js) redireciona pra /pages/wishlist quando o produto ja esta
   na lista. Interceptamos no capture: se ja esta favoritado, removemos e desmarcamos
   (sem navegar); se nao esta, deixamos o tema adicionar (preenche). Ver a lista = coracao do header.
   Vale para cards do catalogo, popup do hotspot e pagina do produto. Reversivel (so este arquivo). */
(function () {
  var KEY = 'shopify-wishlist';

  function list() {
    try { return (localStorage.getItem(KEY) || '').split(',').filter(Boolean); }
    catch (e) { return []; }
  }
  function save(arr) {
    try {
      if (arr.length) localStorage.setItem(KEY, arr.join(','));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }
  function syncCounts(n) {
    var c = document.querySelector('.dtxc-wishlist-count'); if (c) c.setAttribute('count', n);
    var m = document.querySelector('.mobile-dtxc-wishlist-count'); if (m) m.setAttribute('count', n);
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.add-wishlist') : null;
    if (!a) return;
    var handle = a.getAttribute('data-product_handle');
    if (!handle) return;

    var arr = list();
    var idx = arr.indexOf(handle);
    if (idx !== -1) {
      // Ja favoritado: o tema iria redirecionar. Intercepta e ALTERNA (remove + desmarca).
      e.preventDefault();
      e.stopImmediatePropagation();
      arr.splice(idx, 1);
      save(arr);
      a.classList.remove('added', 'adding');
      syncCounts(arr.length);
    }
    // Se nao estava na lista: nao faz nada aqui e deixa o handler do tema adicionar (preenche).
  }, true); // capture: roda antes do handler do tema
})();


/* Pensualizei - PDP: coracao de favoritar ao lado do "Comprar" na pagina do produto.
   Usa o mesmo componente do tema (<dtx-wishlist>) para herdar o estado da lista.
   Reversivel (so este arquivo + o CSS escopado .ps-pdp-wishlist). */
(function () {
  function handle() {
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.handle) {
        return ShopifyAnalytics.meta.product.handle;
      }
    } catch (e) {}
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function inject() {
    var wrap = document.querySelector('.product-form__buttons');
    if (!wrap) return;
    if (wrap.querySelector('.ps-pdp-wishlist')) return; // ja injetado
    var mainBtn = wrap.querySelector('[data-ps-main-submit]') || wrap.querySelector('.product-form__submit');
    if (!mainBtn) return;
    var h = handle();
    if (!h) return;

    // linha flex: botao (cresce) + coracao (quadrado ao lado)
    var row = document.createElement('div');
    row.className = 'ps-pdp-buyrow';
    mainBtn.parentNode.insertBefore(row, mainBtn);
    row.appendChild(mainBtn);
    // o botao vem com min-width:100% (button--full-width) e nao encolheria; forcamos inline
    // (inline !important vence a cascata) pra abrir espaco pro coracao ao lado.
    mainBtn.style.setProperty('flex', '1 1 0', 'important');
    mainBtn.style.setProperty('min-width', '0', 'important');
    mainBtn.style.setProperty('width', 'auto', 'important');
    mainBtn.style.setProperty('margin', '0', 'important');
    // insertAdjacentHTML garante que o <a.add-wishlist> exista ANTES do upgrade do custom element
    row.insertAdjacentHTML('beforeend',
      '<dtx-wishlist class="ps-pdp-wishlist">' +
        '<a href="javascript:void(0);" class="add-wishlist ps-pdp-wishlist__btn" ' +
        'data-product_handle="' + h + '" aria-label="Adicionar a lista de desejos" title="Favoritar"></a>' +
      '</dtx-wishlist>');
  }

  function init() { try { inject(); } catch (e) {} }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
